import React from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";

import SvgIconStyle from "../../../components/SvgIconStyle";
import { dashboardMenu } from "../../../data";
import { setDashboardTab, setSelectCollectionDate } from "../slice";
import { useDispatch } from "react-redux";
import { useCollection } from "../Actions/ActionDate/useCollection";
import { useNavigate } from "react-router-dom";
import CollectionDrawer from "./CollectionDrawer";
import { useTheme } from "@mui/material";

const CollectionList = ({ item, t, setDateValue }) => {
  const theme = useTheme();
  const [drawerState, setDrawerState] = React.useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleDrawer = React.useCallback((value) => {
    setDrawerState(value);
  }, []);

  const handleClick = React.useCallback(() => {
    setDrawerState(true);
  }, []);
  let currentTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <>
      <Paper
        sx={{
          padding: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        variant="outlined"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar
            src="/static/dashboard/map.svg"
            alt="map"
            sx={{ width: "64px", height: "50px" }}
            variant="rounded"
          />
          <Box
            component="div"
            sx={{ display: "flex", flexDirection: "column", px: 1 }}
          >
            <Typography
              fontSize={"Large"}
              fontWeight={600}
              textTransform={"uppercase"}
              fontFamily={"Poppins"}
            >
              {/* D0961278{" "} */}
              {new Date(item.collection.createdDate).getFullYear()}
              {item.collection.id}
              {/* {item.donation.donationId.slice(0, 1) +
              item.donation.donationId.slice(10, 14)}{" "} */}
              <Typography
                display={"inline"}
                fontSize={"small"}
                fontFamily={"Poppins"}
                textTransform={"capitalize"}
                component="span"
                color={"#6E6E6E"}
                ml={1}
              >
                {/* 27-03-2022 */}
                {new Date(item.collection.dateOfCollection).
                toLocaleString("pt", {
                    day: "numeric",
                    month: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    formatMatcher: "best fit",
                    timeZone: currentTimeZone,
                  })
                }
              </Typography>
            </Typography>
            <Box sx={{ display: "flex" }}>
              <Typography
                fontSize={"subheading"}
                fontFamily={"Poppins"}
                sx={{
                  // maxWidth: "500px",
                  // textOverflow: "ellipsis",
                  // overflow: "hidden",
                  // whiteSpace: "nowrap",
                  maxWidth: '100%' ,
                  whiteSpace: 'break-spaces',
                  wordBreak: 'break-word',
                  [theme.breakpoints.up("xs")]: { maxWidth: '100%%' ,whiteSpace: 'break-spaces',wordBreak: 'break-word' },
                  [theme.breakpoints.down("sm")]: {maxWidth: '100%%' ,
                  whiteSpace: 'break-spaces',
                  wordBreak: 'break-word', },

                }}
              >

                 {item.addresses[0]?.addressLine}{", "}{item.addresses[0]?.postalCode}{" "}{item.addresses[0]?.subDivision} 
                {/* {item.addresses[0]?.county} {item.addresses[0]?.subDivision}{" "}
                {item.addresses[0]?.locality} {item.addresses[0]?.postalCode} */}
                {/* Av . São João ( M.A.R.L. ) , 2660-421 São Julião do Tojal */}
                {/* {item.addresses[0]?.addressLine} {item.addresses[0]?.district}{" "}
                {item.addresses[0]?.county} {item.addresses[0]?.subDivision}{" "}
                {item.addresses[0]?.locality} {item.addresses[0]?.postalCode} */}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Button
          sx={{
            bgcolor: "#E1EFB0",
            width: "36px",
            height: "36px",
            minWidth: 0,
            borderRadius:'4px'
          }}
          // onClick={() => {
          //   dispatch(
          //     setSelectCollectionDate(new Date(item.collection.dateOfCollection))
          //   );
          //   setDateValue(new Date(item.collection.dateOfCollection));
          //   navigate(dashboardMenu[2].link);
          // }}
          onClick={handleClick}
        >
          <SvgIconStyle
            src="/static/dashboard/info.svg"
            sx={{ color: "black", width: "16px", height: "16px" }}
          />
        </Button>
      </Paper>
      <CollectionDrawer
        drawerState={drawerState}
        toggleDrawer={toggleDrawer}
        collectionDetail={item}
        t={t}
      />
    </>
  );
};

export default CollectionList;
